module.exports = __webpack_public_path__ + "static/media/hkd-500.dc014889.png";